import { getAuthAxiosBackend } from "../helpers/axios"

class LogServices{

    get(id){
        return getAuthAxiosBackend().get('monitor/log/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('monitor/logs', {params: data})
    }
}

export default new LogServices()